import { Provider } from '@angular/core';
import { PaginatedStateLoadingMode } from '@shared/ui';
import { workspaceDetailProviders, workspacesListProviders } from '../../../providers/store.providers';
import { WorkspaceDetailFacade } from './workspace-detail.facade';

export function workspaceDetailFacadeProviders(): Provider[] {
  return [
    ...workspacesListProviders(PaginatedStateLoadingMode.PAGINATED),
    ...workspaceDetailProviders(),
    WorkspaceDetailFacade,
  ];
}
